<div class="growerSearchModal" (window:resize)="onresize($event)">
  <div class="growerSearchSecOuter">
    <div *ngIf="!addGrower">
      <div class="growerSearchSec">
        <h4>
          First Lets search the grower master database to find your grower:
        </h4>
        <p>
          We will first search for this grower in the grower master database before adding duplicate records. If you can't find them than we can add a new grower record.
        </p>
        <p class="required">
          You are required to select an account  when you search:
        </p>

        <div class="inline-error" *ngIf="enableErrorMsg || gwrCtrl.errors?.pattern || glnCtrl.errors?.pattern">
          <div class="row">
            <div class="col-md-12 ">
              <ol class="error-list">
                <li *ngIf="!gwrCtrl.errors?.pattern && !glnCtrl.errors?.pattern" class="justify-content-center align-self-center">
                  {{ErrorMessage}}
                </li>
                <li *ngIf="gwrCtrl.errors?.pattern">
                  Grower Code is Alphanumeric.
                </li>
                <li *ngIf="glnCtrl.errors?.pattern">
                  Grower Gln is numeric.
                </li>
              </ol>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 grower-search-inner">
            <form #searchGrowerForm="ngForm" autocomplete="off" (ngSubmit)="!(gwrCtrl.errors?.pattern || glnCtrl.errors?.pattern) && searchGrower(searchGrowerForm)">
              <div class="row">
                <div class="col-md-4">
                  <mat-form-field class="wide100" [class.invalid-field]="brwErrorModel.BusinessName">
                    <mat-label>Business Name</mat-label>
                    <input matInput id="txtbusinessName" minlength="3" type="text" name="businessName" [(ngModel)]="brwModel.BusinessName" (focusout)="lengthValidation('BusinessName', brwModel.BusinessName)"
                           #bnCtrl="ngModel" autocomplete="off">
                  </mat-form-field>
                </div>
                <div class="col-md-4">
                  <mat-form-field class="wide100" [class.invalid-field]="brwErrorModel.FirstName">
                    <mat-label>First Name</mat-label>
                    <input matInput id="txtFirstName" type="text" name="firstName" [(ngModel)]="brwModel.FirstName" minlength="3" autocomplete="off" #fnCtrl="ngModel" (focusout)="lengthValidation('FirstName', brwModel.FirstName)">
                  </mat-form-field>
                </div>
                <div class="col-md-4">
                  <mat-form-field class="wide100" [class.invalid-field]="brwErrorModel.LastName">
                    <mat-label>Last Name</mat-label>
                    <input matInput id="txtLastName" type="text" name="lastName" [(ngModel)]="brwModel.LastName" minlength="3" autocomplete="off" #lnCtrl="ngModel" (focusout)="lengthValidation('LastName', brwModel.LastName)">
                  </mat-form-field>
                </div>
              </div>
              <div class="row sellerSearch">
                <div class="col-md-3 marTop12">
                  <mat-form-field class="wide100" [class.invalid-field]="brwErrorModel.GrowerCode">
                    <mat-label>Grower Code</mat-label>
                    <input matInput id="txtGrowerCode" type="text" name="growerCode" autocomplete="off" [(ngModel)]="brwModel.GrowerCode" #gwrCtrl="ngModel" pattern="^[a-zA-Z0-9]+$">
                  </mat-form-field>
                </div>
                <div class="col-md-3 marTop12">
                  <mat-form-field class="wide100" [class.invalid-field]="brwErrorModel.GLN">
                    <mat-label>GLN</mat-label>
                    <input matInput id="txtGln" type="text" name="gln" autocomplete="off" [(ngModel)]="brwModel.GLN" #glnCtrl="ngModel"
                           (keypress)="keyPressNumbers($event)" (focusout)="validateOnFocusOut('gln',brwModel.GLN)">
                  </mat-form-field>
                </div>
                <div class="col-md-3 marTop12">
                  <mat-form-field class="wide100" [class.invalid-field]="brwErrorModel.City">
                    <mat-label>City</mat-label>
                    <input matInput id="txtCity" type="text" name="city" autocomplete="off" [(ngModel)]="brwModel.City" #cityCtrl="ngModel"
                           (focusout)="validateOnFocusOut('city',brwModel.City)">
                  </mat-form-field>
                </div>
                <div class="col-md-3 material-select" [class.invalid-field]="brwErrorModel.State">
                  <ng-select #stateCtrl="ngModel"
                             id="ddlState"
                             name="state"
                             placeholder="State"
                             class="custom-select-grower"
                             [items]="stateDS"
                             [(ngModel)]="brwModel.State"
                             [multiple]="false"
                             [hideSelected]="true"
                             [virtualScroll]="true"
                             bindLabel="value"
                             bindValue="id"
                             [searchFn]="stateSearchFn"
                             [closeOnSelect]="true"
                             (focusout)="validateOnFocusOut('state',brwModel.State)">
                    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                      <div class="dropdown-template">
                        <div class="row">
                          <div class="col-md-8">
                            <p class="name">
                              {{item.value}}
                            </p>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                      <div class="ng-option disabled">
                        No data found for ""
                      </div>
                    </ng-template>
                  </ng-select>
                </div>
              </div>
              <div class="row sellerSearch">
                <div class="col-md-6 material-select">
                  <ng-select id="ddlaccount" [class.invalid-field]="brwErrorModel.ABNumber"
                             name="account"
                             [items]="accountSearchData"
                             placeholder="Account"
                             [(ngModel)]="brwModel.ABNumber"
                             [virtualScroll]="true"
                             bindLabel="accountNameCityState"
                             bindValue="accountNumber"
                             [loading]="accountLoading"
                             class="custom-select-grower"
                             [closeOnSelect]="true"
                             [disabled]="true">

                    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                      <div class="dropdown-template">
                        <div class="row">
                          <div class="col-md-8">
                            <h4 class="name greenColor" [ngOptionHighlight]="search">
                              {{item.accountName}}
                            </h4>
                            <p class="address" [ngOptionHighlight]="search">
                              {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                            </p>
                            <p class="phoneNo" [ngOptionHighlight]="search">
                              {{item.primaryPhoneNumber}}
                            </p>
                            <p class="grower-nos">
                              <span class="grower-gln" [ngOptionHighlight]="search">
                                Account #: {{item.accountNumber}}
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                      <div class="ng-option disabled">
                        No data found for "{{searchTerm}}"
                      </div>
                    </ng-template>
                    <ng-template ng-footer-tmp let-search="searchTerm">
                      <div class="custom-drop-footer">
                        <div class="row">
                          <div class="col-md-8">Select an option above to filter</div>
                          <div class="col-md-4">{{this.accountDataCount}} Results</div>
                        </div>
                      </div>
                    </ng-template>
                  </ng-select>
                </div>
                <div class="col-md-6 text-right marTop12">
                  <button mat-raised-button class="btns btn-height36" color="primary" type="submit">
                    Search
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 filterOuter">
          <app-efulfillmentfilter [filters]="filterArray" [IsFulfilmentTab]="true" (SearchFilter)="filterGrid($event)" [cleanFilter]="clearFtr"></app-efulfillmentfilter>
        </div>
        <div class="col-md-12 growerSearchTable">
          <app-efulfillmenttable [propHeaderDS]="headerList" [propBodyDS]="growerDS" (RowClick)="saveSelectedGrower($event, searchGrowerForm)"></app-efulfillmenttable>
        </div>
      </div>
      <div class="row tableTotalsSec" *ngIf="enableAddGrower">
        <div class="col-md-12">
          <h4>I can’t find the grower I am looking for:</h4>
          <span style="font-size:12px;font-family:Akzidenz-Grotesk Std">{{growerSearchNotFoundMessage}}</span> <br />
          <button mat-raised-button class="btns" color="primary" style="margin-top:10px;" (click)="openAddGrowerModel(true)">Create New Grower</button>
        </div>
      </div>
    </div>
    <div *ngIf="addGrower">
      <app-grower-add [usedAsNestedComp]="usedAsNestedComp" [growerSearchType]="growerSearchType" (GrowerAddToSystem)="hideAddGrower($event)"></app-grower-add>
    </div>
  </div>
</div>
